import React from "react";
import { Box } from "@mui/material";
import Copyrighttext from "./Copyrighttext.jsx";

// Single mount: rendering one Copyrighttext with responsive spacing keeps a
// single useFooterMode instance (the previous xs/sm display-toggled pair ran
// two live ResizeObservers over the same scroll container).
const CopyRightTextMain = () => {
  return (
    <Box sx={{ mt: { xs: 2, sm: 0 } }}>
      <Copyrighttext />
    </Box>
  );
};

export default CopyRightTextMain;
